import { observer } from 'mobx-react-lite'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { EnterNumberCommon } from 'pages/settings/ui/EnterNumberCommon'

export const EnterNumber = observer(() => {
  const {
    textEnableLandlineStore: { enterNumberStore },
    nextClickHandler,
  } = useNewInboxStepsContext()

  return <EnterNumberCommon store={enterNumberStore} nextClickHandler={nextClickHandler} />
})
